// Locale-aware date helpers for the calendar UI. Components pass the active
// i18next language (e.g. 'de', 'sv', 'no'); these map it to a BCP47 locale and
// derive month/weekday names via Intl so the calendar reads in the user's
// language instead of hardcoded English.

/** Map an i18next language code to a BCP47 locale for Intl date formatting. */
export function uiLocale(lng: string | undefined): string {
  if (!lng) return 'en-GB'
  if (lng.startsWith('no')) return 'nb' // Norwegian Bokmål — correct month/day names
  if (lng.startsWith('en')) return 'en-GB' // keep day-first English formatting
  return lng
}

export function monthLong(locale: string, month0: number): string {
  return new Date(2021, month0, 1).toLocaleDateString(locale, { month: 'long' })
}

export function monthShort(locale: string, month0: number): string {
  return new Date(2021, month0, 1).toLocaleDateString(locale, { month: 'short' })
}

/** Short weekday names, Monday-first (matches the calendar grid). */
export function weekdaysShortMonFirst(locale: string): string[] {
  // 2024-01-01 is a Monday.
  return Array.from({ length: 7 }, (_, i) =>
    new Date(2024, 0, 1 + i).toLocaleDateString(locale, { weekday: 'short' }),
  )
}
